import APP from 'src/main.js'
import AppRecord from './AppRecord.js'

class AllocationLimit extends AppRecord {
  get parent(){
    return this.constructor.employeeStore.entitiesById.get(this.entity_id)
  }

  get formatted_max_pct(){
    return (this.max_pct * 100).round(2)
  }

  set formatted_max_pct(value){
    this.max_pct = value != 0 ? value /100 : 0
  }

  get formatted_min_pct(){
    return (this.min_pct * 100).round(2)
  }

  set formatted_min_pct(value){
    this.min_pct = value != 0 ? value /100 : 0
  }
  get formatted_reporting_pct(){
    return (this.reporting_pct * 100).round(2)
  }

  set formatted_reporting_pct(value){
    this.reporting_pct = value != 0 ? value /100 : 0
  }
  get entity(){
    return this.constructor.employeeStore.entitiesById.get(this.entity_id)
  }
  get entity_long_name(){
    if(this.entity){
      return this.entity.long_name
    } else {
      return undefined
    }
  }

  get entityAllocation(){
    return this.constructor.employeeStore.entity_allocations.find(e => e.id === this.entity_allocation_id)
  }

  get isStrategy(){
    return this.entityAllocation?.isStrategy
  }

  get assetClassGroups(){
    return this.constructor.employeeStore.asset_class_groups.filter(acg => acg.asset_class === this.asset_class)
  } 

  get active(){
    let now = new Date().to_s()
    let activeDate = this.from ? this.from : '1900-01-01'

    let allocationLimitsSorted = this.constructor.employeeStore.allocation_limits.filter(a => a.entity_id === this.entity_id && a.asset_class == this.asset_class && a.asset_class_group_id == this.asset_class_group_id && a.id != this.id)
    .sort((a, b) => {
      if (a.from > b.from){ return 1 }
      if (b.from > a.from){ return -1 }
      return 0
    })
    
    let next = allocationLimitsSorted.find(alloc => alloc.from >= activeDate)
    
    if (next && next.from <= now){
      return false
    }

    return true
  }

  get assetClassGroup(){
    return this.constructor.employeeStore.asset_class_groups.find(acg => acg.id === this.asset_class_group_id)
  }

  get assetClassDescription(){
    if (this.asset_class){
      if (this.assetClassGroup){
        return this.asset_class + ' - ' + this.assetClassGroup.name
      }
      return this.asset_class
    }

    return ''
  }

  get percentageDistrubution(){
    if (this.isStrategy){
      return this.formatted_reporting_pct
    } else {
      return this.formatted_min_pct + ' - ' + this.formatted_max_pct
    }
  }

  get isPrimary(){
    if (this.asset_class_group_id === null) { return true }

    return false
  }

  get secondaryAllocationLimits(){
    if (! this.isPrimary) { return null }
  
    return this.constructor.employeeStore.allocation_limits.filter(alloc => alloc.entity_allocation_id === this.entity_allocation_id && alloc.asset_class == this.asset_class && !alloc.isPrimary )
  }
}

export default AllocationLimit
